// Copyright (c) Microsoft. All rights reserved.

import * as signalR from "@microsoft/signalr";

const signalRHubConnection = (baseUrl: string) => {
  const connectionHubUrl = new URL(baseUrl + "/chatHub");
  const signalRConnectionOptions = {
    skipNegotiation: true,
    transport: signalR.HttpTransportType.WebSockets,
    logger: signalR.LogLevel.Warning,
  };
  // Create the connection instance
  // withAutomaticReconnect will automatically try to reconnect and generate a new socket connection if needed
  return new signalR.HubConnectionBuilder()
    .withUrl(connectionHubUrl.toString(), {
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
    })
    .build();
};

export default signalRHubConnection;
